import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";
import { getOrganizations } from "api/api";
import getOrganizationsTableData from "./data/getTableData";
import MDButton from "components/MDButton";
import CreateOrganization from "./create_organization_form";
import { CheckPermissionRender } from "../../helpers/checkPermission";
import permissions from "../../config/permissions";
import UpdateOrganizationForm from "./update_organization_form";
import MobileNavbar from "examples/Navbars/MobileNavbar";
import { useIsMobile } from "hooks/useIsMobile";
import AccountPopup from "./account_popup";

function Organizations() {
  const [state, setState] = useState({
    columns: [],
    rows: [],
    createModalOpen: false,
  });

  const isMobile = useIsMobile();

  const [itemToEdit, setItemToEdit] = useState(null);
  const [organization, setOrganization] = useState(null);

  const [openAccountPopup, setOpenAccountPopup] = useState(false);

  const getAllItems = async () => {
    const items = await getOrganizations();
    if (items) {
      const { columns, rows } = getOrganizationsTableData(items, onEdit, openAccountPopupHandler);
      setState({ ...state, columns: columns, rows: rows, createModalOpen: false });
      setItemToEdit(null);
    }
  };
  useEffect(() => {
    getAllItems();
  }, []);

  const createModel = (open) => {
    setState({ ...state, createModalOpen: open });
  };

  const onEdit = (user) => {
    setItemToEdit(user);
  };

  const openAccountPopupHandler = (organization) => {
    setOrganization(organization);
    setOpenAccountPopup(true);
  };

  return (
    <DashboardLayout>
      <MobileNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems={isMobile ? "left" : "center"}
                flexDirection={isMobile ? "column" : "row"}
                gap={1}
              >
                <MDTypography variant="h6" color="white">
                  Organizations
                </MDTypography>
                <CheckPermissionRender permissions={permissions().organization().create().list()}>
                  <MDButton
                    onClick={() => {
                      createModel(true);
                    }}
                    variant="gradient"
                    color="dark"
                    style={{ width: "fit-content" }}
                  >
                    add new organization
                  </MDButton>
                </CheckPermissionRender>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns: state.columns, rows: state.rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <CheckPermissionRender permissions={permissions().organization().create().list()}>
        <CreateOrganization
          open={state.createModalOpen}
          onClose={() => {
            createModel(false);
          }}
          reload={getAllItems}
        />
      </CheckPermissionRender>
      <CheckPermissionRender permissions={permissions().organization().update().list()}>
        <UpdateOrganizationForm
          organization={itemToEdit}
          onClose={() => {
            setItemToEdit(null);
          }}
          reload={getAllItems}
        />
      </CheckPermissionRender>
      <CheckPermissionRender permissions={permissions().organization().update().list()}>
        <AccountPopup
          open={openAccountPopup}
          setOpen={setOpenAccountPopup}
          organization={organization}
        />
      </CheckPermissionRender>
    </DashboardLayout>
  );
}

export default Organizations;
